module.exports = __webpack_public_path__ + "img/lg_ring_y_o_0_0.fd75194b.png";